import "./FloatingTextFiled.css";
import React, { useRef } from "react";
import { TextField } from "@mui/material";

const FloatingTextFiled = React.forwardRef(
  (
    {
      className = "",
      disabled = false,
      forLabel,
      id,
      label,
      onBlur,
      onChange,
      onClick,
      // placeholder, // not used — MUI uses label for the floating label
      type = "text",
      value,
      focusedAllowed = true,
      maxLength,
    },
    ref
  ) => {
    const inputRef = useRef(null);
    const isInvalid = className.includes("invalid");
    const hasValue = !!(value && value !== "$" && focusedAllowed);
    const wrapperClass = className.replace(/\binvalid\b/, "").trim();

    return (
      <div className={`CopyItCustomInput ${wrapperClass}`} onClick={onClick}>
        <TextField
          disabled={disabled}
          id={id || forLabel}
          inputRef={ref || inputRef}
          label={label}
          onBlur={onBlur}
          onChange={onChange}
          type={type}
          value={value ?? ""}
          variant="outlined"
          size="small"
          slotProps={{
            htmlInput: {
              ...(typeof maxLength === "number" ? { maxLength } : {}),
              style: { padding: "14px", outline: "none" }, // inline style wins over MUI's Emotion-generated class padding
            },
          }}
          sx={{
            width: "100%",
            "& .MuiFormLabel-root": {
              fontSize: "14px",
              fontFamily: "Graphik Medium",
              color: "#9A9B9B",
              paddingTop: "6px", // matches ExactDateSelector — centers label in the 55px container for size="small"
            },
            "& .MuiFormLabel-root.Mui-focused": {
              color: "#9A9B9B",
            },
            // "& .MuiInputBase-inputSizeSmall": { padding: "14px" }, // moved to slotProps.htmlInput inline style — Emotion class was winning over sx selector
            "& .MuiOutlinedInput-notchedOutline legend": {
              lineHeight: "11px",
              fontSize: "9.75px",
            },
            "& .MuiOutlinedInput-root": {
              minHeight: "55px",
              fontSize: "14px",
              color: "#000", // typed text is black (DatePicker uses #9A9B9B for date value)
              fontFamily: "Graphik Medium",
              borderRadius: "12px",
              backgroundColor: hasValue ? "#ffffff" : "#f7f7f7",
              "& fieldset": {
                borderColor: isInvalid
                  ? "red"
                  : hasValue
                  ? "#11B700"
                  : "rgba(0, 0, 0, 0.23)",
                borderWidth: hasValue ? "2px" : "1px",
                borderRadius: "12px",
              },
              // Hover only when enabled — disabled fields stay static
              "&:hover:not(.Mui-disabled)": {
                backgroundColor: "#ffffff",
              },
              "&:hover:not(.Mui-disabled) fieldset": {
                borderColor: isInvalid ? "red" : "#11B700",
                borderWidth: "2px",
              },
              "&.Mui-focused": {
                backgroundColor: "#ffffff",
              },
              "&.Mui-focused fieldset": {
                borderColor: isInvalid ? "red" : "#11B700",
                borderWidth: "2px",
              },
              "&.Mui-disabled": {
                backgroundColor: "#f7f7f7",
                cursor: "not-allowed",
              },
              "&.Mui-disabled:hover": {
                backgroundColor: "#f7f7f7",
              },
              "&.Mui-disabled fieldset": {
                borderColor: "rgba(0, 0, 0, 0.23)",
                borderWidth: "1px",
              },
              "&.Mui-disabled:hover fieldset": {
                borderColor: "rgba(0, 0, 0, 0.23)",
                borderWidth: "1px",
              },
            },
          }}
        />
      </div>
    );
  }
);

export default FloatingTextFiled;
